import type { ContentfulPageResponseModel } from '~~/server/api/contentful/index.get';
import { contentfulPageCacheMatchesRequest } from '~/utils/contentful/contentfulPageCacheMatchesRequest';
import { isContentfulPageRedirectResponse } from '~/utils/contentful/isContentfulPageRedirectResponse';

export function buildContentfulPageSyncFetchKey(
  when: boolean,
  id: string | undefined,
  slug: string | undefined,
  locale: string
): string {
  return [when ? '1' : '0', id ?? '', slug ?? '', locale].join('|');
}

export function shouldSkipContentfulPageFetch(when: boolean): boolean {
  return !when;
}

export function canFetchContentfulPage(
  id: string | undefined,
  slug: string | undefined
): boolean {
  return Boolean(id) || slug !== undefined;
}

export function buildContentfulApiSlug(
  slug: string | undefined
): string | undefined {
  return slug === '' ? undefined : slug;
}

export function canReuseContentfulPageCache(
  cachedData: ContentfulPageResponseModel | null | undefined,
  id: string | undefined,
  slug: string | undefined
): boolean {
  if (cachedData == null) {
    return false;
  }

  if (isContentfulPageRedirectResponse(cachedData)) {
    return false;
  }

  return contentfulPageCacheMatchesRequest(cachedData, id, slug);
}
